import { StakingTokenType } from 'types/farms'

import { BaseMemoryFilter, FarmFilterGroup, FilterSelectionMode } from '../filterTypes'

export type FarmMemoryFilter = BaseMemoryFilter

export const islandTokenFilter: FarmMemoryFilter = {
  displayName: 'Island',
  isActive: false,
  group: FarmFilterGroup.StakingTokenType,
  selectionMode: FilterSelectionMode.MULTI,
  priority: 0,
}

export const v2TokenFilter: FarmMemoryFilter = {
  displayName: 'V2',
  isActive: false,
  group: FarmFilterGroup.StakingTokenType,
  selectionMode: FilterSelectionMode.MULTI,
  priority: 1,
}

export const charmTokenFilter: FarmMemoryFilter = {
  displayName: 'Charm',
  isActive: false,
  group: FarmFilterGroup.StakingTokenType,
  selectionMode: FilterSelectionMode.MULTI,
  priority: 2,
}

export const genericTokenFilter: FarmMemoryFilter = {
  displayName: 'Generic',
  isActive: false,
  group: FarmFilterGroup.StakingTokenType,
  selectionMode: FilterSelectionMode.MULTI,
  priority: 3,
}

// Active Filter - TOGGLE (independent on/off)
export const activeOnlyFilter: FarmMemoryFilter = {
  displayName: 'Active Only',
  isActive: true,
  group: FarmFilterGroup.Active,
  selectionMode: FilterSelectionMode.TOGGLE,
  priority: 4,
}

export const lowTvlFarmsFilter: FarmMemoryFilter = {
  displayName: 'Hide Low TVL',
  isActive: true, // Default on like islands
  group: FarmFilterGroup.LowTvl,
  selectionMode: FilterSelectionMode.TOGGLE,
  priority: 5,
}

export const allFarmFilters = [
  islandTokenFilter,
  v2TokenFilter,
  charmTokenFilter,
  genericTokenFilter,
  activeOnlyFilter,
  lowTvlFarmsFilter,
]

export const farmFilterRegistry = allFarmFilters.reduce((acc, filter) => {
  acc[filter.displayName] = filter
  return acc
}, {} as Record<string, FarmMemoryFilter>)

export const filterNameToStakingTokenType: Record<string, StakingTokenType> = {
  Island: StakingTokenType.ISLAND,
  V2: StakingTokenType.V2,
  Charm: StakingTokenType.CHARM,
  Generic: StakingTokenType.GENERIC,
}
